export enum TythonColumnsEnum {
  ImpressionRequests = 'ImpressionRequests',
  ImpressionsReturned = 'ImpressionsReturned',
  ImpressionsServed = 'ImpressionsServed',
  ImpressionsViewed = 'ImpressionsViewed',
  Viewability = 'Viewability',
  Revenue = 'Revenue',
  WinningBids = 'WinningBids',
  WinRate = 'WinRate',
  eCPM = 'eCPM',
  Clicks = 'Clicks',
  CTR = 'CTR',
  FillRate = 'FillRate',
  Impressions = 'Impressions',
  ViewableImpressions = 'ViewableImpressions',
  MeasurableImpressions = 'MeasurableImpressions',
  ImpressionsRate = 'ImpressionsRate',
  EligibleImpressions = 'EligibleImpressions',
  MeasurableImpressionsRate = 'MeasurableImpressionsRate',
  ResponsesServed = 'ResponsesServed',
  DateTime = 'DateTime',
  AdUnitName = 'AdUnitName',
  Country = 'Country',
  CountryCode = 'CountryCode',
  AdECPM = 'AdECPM',
  AdClicks = 'AdClicks',
  AdCTR = 'AdCTR',
  Date = 'Date',
  AdUnitId = 'AdUnitId',
  SiteName = 'SiteName',
  PropertyUrl = 'PropertyUrl',
  OperatingSystem = 'OperatingSystem',

  AccountId = 'AccountId',
  AccountName = 'AccountName',
  Currency = 'Currency',
  PublisherId = 'PublisherId',
  PublisherName = 'PublisherName',
  SiteId = 'SiteId',
  AdDistribution = 'AdDistribution',
  RequestedLanguage = 'RequestedLanguage',
  RequestedCountry = 'RequestedCountry',
  WebsiteCountry = 'WebsiteCountry',
  UserCountry = 'UserCountry',
  WebsiteLanguage = 'WebsiteLanguage',
  FormCode = 'FormCode',
  DistributionPartnerCode = 'DistributionPartnerCode',
  AdCountry = 'AdCountry',
  DeviceType = 'DeviceType',

  BiddedCTR = 'BiddedCTR',
  BiddedSRPVs = 'BiddedSRPVs',
  NonBillableSRPVs = 'NonBillableSRPVs',
  RawSRPVs = 'RawSRPVs',
  EstimatedRevenue = 'EstimatedRevenue',
  SRPV = 'SRPV',
  CPC = 'CPC',
  SiteUrl = 'SiteUrl',
  TypeTag = 'TypeTag',
  EstimatedRevenueInUSD = 'EstimatedRevenueInUSD',
  AdDensity = 'AdDensity',
  BiddedRPM = 'BiddedRPM',
  PTQs = 'PTQS',
  PTQSRemediationStatus = 'PTQSRemediationStatus',
  PartnerCode = 'PartnerCode',
  PartnerTag = 'PartnerTag',
  ARPV = 'ARPV',
  ImpactScore = 'ImpactScore',
  ClickYield = 'ClickYield',
  Coverage = 'Coverage',
  AdImpressions = 'AdImpressions',
  RPM = 'RPM',
  NumberOfWeeks = 'NumberOfWeeks',
  ModifiedDate = 'ModifiedDate',
  Action = 'Action',
  SelectTierEligibilityStatus = 'SelectTierEligibilityStatus',
  PreviousSelectTierEligibilityStatus = 'PreviousSelectTierEligibilityStatus',
  SelectTierDowngradeReason = 'SelectTierDowngradeReason',
  PTQS = 'PTQS',
  PTQSRemediation = 'PTQSRemediation',
  FollowOnType = 'FollowOnType',
  RedirectionPhase = 'RedirectionPhase',
  Market = 'Market',
  Device = 'Device',
  P50_Latency_ms = 'P50_Latency_ms',
  P50_Latency_ms_7DMA = 'P50_Latency_ms_7DMA',
  P90_Latency_ms = 'P90_Latency_ms',
  P90_Latency_ms_7DMA = 'P90_Latency_ms_7DMA',
  ContentExperience = 'ContentExperience',
  PageViews = 'PageViews',
  UniqueUsers = 'UniqueUsers',
  Experience = 'Experience',
  StartDistributionRpm = 'StartDistributionRPM',
  NetRevenue = 'NetRevenue',
  TotalPartnerRevenueShare = 'TotalPartnerRevenueShare',
  ProjectId = 'ProjectId',
  ClarityCoverage_PageViewBased = 'ClarityCoverage_PageViewBased',
  ClarityCoverage_ClickBased = 'ClarityCoverage_ClickBased',
}
